<template>
    <div class="avatar-box m-2 d-flex justify-content-center">

                <div :id="avatar.id" class="position-relative">
                    <img
                        :src="`https://assets.beeverso.org/avatar/${avatar.name}/${avatar.value}`"
                        class="transition-all img-avatar"
                        alt="Avatar"
                        :height="$vuetify.breakpoint.xs ? '76' : '144'"
                        :width="$vuetify.breakpoint.xs ? '76' : '144'"
                    />
                    <img
                        :src="`https://assets.beeverso.org/avatar/${avatar.name}/${avatar.value}`"
                        class="blur-background"
                        alt="Avatar"
                        :height="$vuetify.breakpoint.xs ? '76' : '144'"
                        :width="$vuetify.breakpoint.xs ? '76' : '144'"
                    />
                </div>
    </div>
</template>

<script>
import { DEFAULT_AVATAR } from "@/constants/DefaultConstants"

export default {
    props: {
        avatar: {
            type: Object,
            default: DEFAULT_AVATAR,
        },
        progress: Number
    },
    data() {
        return {
            gradient: {
                radial: false,
                colors: [
                    {
                        color: '#FFDA00',
                        offset: '0',
                        opacity: '1'
                    },
                    {
                        color: '#FFC400',
                        offset: '100',
                        opacity: '1'
                    }
                ]
            }
        }
    }
}
</script>

<style lang="css" scoped>

.avatar-box img{
    border-radius: 100%;
}
.img-avatar{
    position: relative;
    z-index: 2;
    border-radius: 100%;
}
.blur-background{
    filter: blur(20px);
    -webkit-filter: blur(20px);
    height: 110%;
    width: 110%;
    position: absolute;
    right: -5%;
    top: 4%;
    z-index: 1;
}
</style>
